module.exports = __webpack_public_path__ + "static/img/tusheti.001504e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/tusheti.jpg
// module id = skNl
// module chunks = 1